import React, {
    Component
} from 'react';
import * as Config from '../config/Config';
import * as User from '../helpers/User';
import * as Common from '../helpers/Common';
import Flowplayer from '../components/Flowplayer';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getLearningRoom } from '../actions/learningRoomAction';
const $ = window.$;

class Videocomponent extends Component {
    constructor(props) {
        super(props);
        this.compeletestatus = "";
        this.state = {
            vediocnt: [],
            isAdimage: null,
            images: [],
            playersem: null
        };
    }
    getVideocomponents(data) {

        let trackData = {
            compseq_id: data.compseq_id,
            lroom_id: data.learning_room_id,
            divider_id: data.divider_id,
            learner_id: data.learner_id,
            dlr_id: data.dlr_id,
            compo_type: data.compo_type
        };
          
        Common.reactLoader("show", "Please wait...");
        fetch(Config.domainUrl + 'videocomponent/getvideocomponent', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Common.getTokenData()
            },
            body: JSON.stringify({
                data,
                learner_id: User.UserId()
            })
        }).then((response) => response.json()).then((responseJson) => {

            this.setState({
                playersem: <Flowplayer playlist={responseJson.videotracks} trackData={trackData} vcdata={data} />,
                vediocnt: responseJson.data,
                isAdimage: responseJson.isAdimage
            });
            setTimeout(() => {
                Common.contentResizeLoad();
                Common.showSmallLeftMenu();
                Common.contentResizeLoad();
                Common.reactLoader("hide");
                //$("html,body").animate({scrollTop : $(".videoscroll").position().top + ($(".videoscroll").outerHeight(true)/2)},300);
                if ($(".videoscroll").length > 0){
                    $("html,body").animate({ scrollTop: $(".videoscroll").position().top }, 300);
                }
            }, 200);
        });
    }
    
    componentDidMount() {
        const {
            data
        } = this.props;
        this.compeletestatus = data.status;
        this.getVideocomponents(data);
        let imageArr = [];
        imageArr[0] = Config.rootDomainUrl + '/361_includes/images/Ads/Bennett.jpg';
        imageArr[1] = Config.rootDomainUrl + '/361_includes/images/Ads/IFIM.jpg';
        imageArr[2] = Config.rootDomainUrl + '/361_includes/images/Ads/Manav.jpg';
        imageArr[3] = Config.rootDomainUrl + '/361_includes/images/Ads/RMS.jpg';
        this.setState({
            images: imageArr
        });
        setTimeout(() => {
            this.changeImage(1)
        }, 10000);

    }
    changeImage(x) {
        if (this.state.isAdimage === '1') {
            $('.videoadd').show();
            let img = document.getElementById("img");
            if (img !== null) {
                img.src = this.state.images[x];
                x++;
            }
            if (x >= this.state.images.length) {
                x = 0;
            }
            setTimeout(() => {
                this.changeImage(x)
            }, 5000);
        }
    }
    componentWillReceiveProps(nextProps) {
        const {
            data
        } = nextProps;
        this.compeletestatus = data.status;
        this.getVideocomponents(data);
    }
    adimaes() {
        return (<div className="videoadd">
            <img id="img" src={Config.rootDomainUrl + '/361_includes/images/Ads/IFIM.jpg'} alt="" />
        </div>);
    }
    onsubmit() {
        const {
            data
        } = this.props;
        Common.reactLoader("show", "Please wait...");
        fetch(Config.domainUrl + 'videocomponent/saveall', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Common.getTokenData()
            },
            body: JSON.stringify({
                compseq_id: data.compseq_id,
                lroom_id: data.learning_room_id,
                divider_id: data.divider_id,
                learner_id: User.UserId(),
                dlr_id: data.dlr_id
            })
        }).then((response) => response.json()).then((responseJson) => {
            Common.reactLoader("hide");
            this.props.getLearningRoom();
            if (responseJson.isCompletedFully) {
                this.goToThanksPage();
            } else {
                this.props.switchback(responseJson.type, responseJson.lr_id, responseJson.dlr_id);
            }
            Common.composcroll();
        });
    }
    goToThanksPage() {
        const {
            data
        } = this.props;
        let sdd = {
            "status": "completed",
            "learning_room_id": data.learning_room_id,
            "compseq_id": data.compseq_id,
            "divider_id": data.divider_id,
            "dlr_id": data.dlr_id,
            "learner_id": data.learner_id,
            "is_ag": data.is_ag,
            "id": data.id,
            "compo_type": "thanks",
            "look_before": data.compseq_id,
            "flowresult": true
        }
        this.props.returnthanks(sdd);
    }
    backToComponentList() {
        const {
            data
        } = this.props;
        this.props.switchback('component_list', data.learning_room_id, data.dlr_id);
    }

    submitbuttons() {
        if (this.compeletestatus === 'completed') {
            return <div id="InActive" className="button">
                <input name="cancel" id="cancel" value="Continue" className="button_org_inactive" alt="Continue" title="Continue" type="button" onClick={(e) => this.backToComponentList()} />
            </div>
        } else {
            return <div id="Active">
                <input name="cancel" id="cancel" value="Will watch later" className="button-cancel" alt="Will watch later" title="Will watch later" type="button" onClick={(e) => this.backToComponentList()} />
                <input name="pqqroceed" id="pqqroceed" value="Next" className="button-accept" alt="Next" title="Next" type="submit" onClick={e => this.onsubmit()} />
            </div>
        }
    }

    render() {
        let vdata = this.state.vediocnt;
        return (
            <div className="main-inner">
                <div className="border-box">
                    <div className={vdata.base_line ? "title-box" : "title-box tit-new"}>
                        <div title="Videocomponents" className="vc_active_button"></div>
                        <h6>{vdata.videocomponent_name ? vdata.videocomponent_name : ''}</h6>
                        <span>{vdata.base_line ? vdata.base_line : ''}</span>
                    </div>
                    <section className="scrol" id="smana-scroll-inner">
                        <section className="viewport">
                            <section className="overview">
                                <div className="inner-content">
                                    <div className="lr-gray-box videogray videoscroll">
                                        {this.state.playersem}
                                        {(this.state.isAdimage === '1') ? this.adimaes() : ''}
                                        <div className="slash_txtLP rgbtn">
                                            <div className="button">
                                                {this.submitbuttons()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </section>
                    </section>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {

    return bindActionCreators({ getLearningRoom }, dispatch);

}

export default connect(null, mapDispatchToProps)(Videocomponent);



// WEBPACK FOOTER //
// ./src/lr_dlr_components/Videocomponent.js